import { SUBSCRIPTION_TITLE } from 'constants/subscriptions';
import { ProductCodes } from 'constants/payments';

const getSubscriptionName = (productCode: ProductCodes, isUpgrade: boolean, productDescription?: string | null) => {
    if (productDescription) return productDescription;

    if (isUpgrade) {
        return SUBSCRIPTION_TITLE.APP_FULL_ACCESS_UPGRADED;
    }

    if (productCode === ProductCodes.APP_FULL_ACCESS) {
        return SUBSCRIPTION_TITLE.APP_FULL_ACCESS;
    }

    if (SUBSCRIPTION_TITLE[productCode]) {
        return SUBSCRIPTION_TITLE[productCode];
    }

    return SUBSCRIPTION_TITLE.OTHER;
};

export default getSubscriptionName;
